var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Phone",
    d: "M120.307,28.14c1.566-2.8,7.065-5.421,10.2-5.476s3.036,4.144,3.031,4.153a20.125,20.125,0,0,0,8.035-5.239,20.088,20.088,0,0,0,5.238-8.034c-.01,0-4.209.1-4.155-3.034s2.679-8.634,5.479-10.2,8.289,3.081,7.836,8.754-3.984,12.672-9.112,17.8-12.129,8.662-17.8,9.114-10.318-5.035-8.754-7.837",
    transform: "translate(-120 -0.004)",
    fill: "#e62e2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPhone);
export default __webpack_public_path__ + "static/media/RedPhone.3c49b06080d21c887fd26b48aafbe0a9.svg";
export { ForwardRef as ReactComponent };